/**
 * Separates single clicks from double clicks on the same element.
 */
export class ClickDebouncer {
    private timer: ReturnType<typeof setTimeout> | null = null;

    constructor(private readonly delay = 200) {}

    click(action: () => void): void {
        this.cancel();
        this.timer = setTimeout(() => {
            this.timer = null;
            action();
        }, this.delay);
    }

    dblClick(action: () => void): void {
        this.cancel();
        action();
    }

    cancel(): void {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
}
